export enum DomOverFlgEnum {
  DOMESTIC = '1',
  OVERSEAS = '2',
}

export const DomOverFlg = [
  { label: '国内', value: DomOverFlgEnum.DOMESTIC },
  { label: '海外', value: DomOverFlgEnum.OVERSEAS },
];
